import { render, staticRenderFns } from "./CompanySwitcher.vue?vue&type=template&id=1cb08752&scoped=true"
import script from "./CompanySwitcher.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompanySwitcher.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CompanySwitcher.vue?vue&type=style&index=0&id=1cb08752&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb08752",
  null
  
)

export default component.exports